import { IStoreEntityStateSlice, createEntitySlice, IStoreVoidEntityStateSlice, createVoidEntitySlice, IFactorConfiguration } from '@aston/foundation';
import { AppConfiguration } from 'apps/console/src/app/app.configuration';
import { SalesConditionsDocument } from 'apps/console/src/app/shared-module/models';
import { IAccountInformationModel } from 'apps/console/src/app/user-module/models';

export interface IAppState {
	app: IStoreVoidEntityStateSlice;
	isFinished: boolean;
	validatorsLoaded: boolean;
	config: IStoreEntityStateSlice<AppConfiguration>;
	factorConfig: IStoreEntityStateSlice<IFactorConfiguration>;
	isScrolling: boolean;
	user: IStoreEntityStateSlice<IAccountInformationModel>;
	salesConditions: IStoreEntityStateSlice<SalesConditionsDocument>;
}

export const initialState: IAppState = {
	app: createVoidEntitySlice(),
	isFinished: false,
	validatorsLoaded: false,
	config: createEntitySlice(),
	factorConfig: createEntitySlice(),
	isScrolling: false,
	user: createEntitySlice(),
	salesConditions: createEntitySlice(),
};
